<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Cameras</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-camera" />
            Cameras
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="showCreateItemModal">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-3 py-3">
        <CRow>
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              :per-page="table.perPage"
              :current-page="table.currentPage"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div>
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 + ((table.currentPage-1)*10) }}
              </template>
              <template #cell(created_at)="row">
                {{ $helper.showData(row.value, "longDate") }}
              </template>
              <template #cell(actions)="row">
                <CButton size="sm" color="warning" style="color: white;" @click="showEditItemModal(row.item.id, row.item.name)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-pencil" />
                </CButton> 
                <CButton size="sm" color="danger" @click="showDeleteItemModal(row.item.id, row.item.name)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-trash" />
                </CButton>
              </template>
            </b-table>
            <CCardFooter>
              <b-row>
                <b-col md="8" cols="12">
                  <div class="my-2">{{ table.totalViewText }}</div>
                </b-col>
                <b-col md="4" cols="12">
                  <b-pagination class="mb-0" align="right"
                    v-model="table.currentPage"
                    :total-rows="table.totalRows"
                    :per-page="table.perPage"
                  />
                </b-col>
              </b-row>
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showCreateEditItemModal" :centered="true">
        <div slot="header"><h5>{{ (createEditItemAction == 'create') ? 'Create' : 'Edit' }} Camera</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditItem.name.feedback"
                label="Name"
                label-for="camera-name"
                :state="createEditItem.name.isValid"
              >
                <b-form-input
                  v-model="createEditItem.name.value"
                  :state="createEditItem.name.isValid"
                  placeholder="Name"
                  maxlength="50"
                  id="camera-name"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showCreateEditItemModal = false">Back</CButton>
          <CButton class="ml-2" v-if="createEditItemAction == 'create'" color="primary" type="submit" @click="createItem" :disabled="isLoading.createEditItem">
            <b-spinner small type="grow" v-if="isLoading.createEditItem" /> 
            {{ isLoading.createEditItem ? 'Loading...' : 'Save' }}
          </CButton>
          <CButton class="ml-2" v-else color="primary" type="submit" @click="editItem" :disabled="isLoading.createEditItem">
            <b-spinner small type="grow" v-if="isLoading.createEditItem" /> 
            {{ isLoading.createEditItem ? 'Loading...' : 'Save' }}
          </CButton>
        </div>
      </CModal>
    </CForm>

    <CModal :closeOnBackdrop="false" :show.sync="showingDeleteModal" :centered="true">
      <div slot="header"><h5>Confirm Delete Camera</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Are you sure you want to delete the following camera?
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol col="4">
            ID
          </CCol>
          <CCol col="8">
            : {{ deleteItem.id }}
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol col="4">
            Name
          </CCol>
          <CCol col="8">
            : {{ deleteItem.name }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" variant="outline" @click="showingDeleteModal = false">Cancel</CButton>
        <CButton class="ml-2" color="danger" type="submit" @click="confirmDeleteItem" :disabled="isLoading.deleteItem">
          <b-spinner small type="grow" v-if="isLoading.deleteItem" /> 
          {{ isLoading.deleteItem ? 'Loading...' : 'Delete' }}
        </CButton>
      </div>
    </CModal>

  </CContainer>
</template>

<script>
export default {
  name: 'Cameras',
  data() {
    return {
      showingDeleteModal: false,
      deleteItem: {
        id: '0',
        name: "",
      },
      isLoading: {
        createEditItem: false,
        deleteItem: false,
      },
      showCreateEditItemModal: false,
      createEditItemAction: 'create',
      selectedItemId: 0,
      createEditItem: {
        name: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "name"
        },
      },
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "name", label: "Name", sortable: true},
          {key: "created_at", label: "Created At", sortable: true},
          { key: "actions", label: "Actions", sortable: false, class:"custom-column-action-user" }
        ],

        items: [
          // {
          //   id: "a2cd4",
          //   name: "john@doe.com",
          //   created_at: "2022-02-22 10:00:00"
          // },
          // {
          //   id: "a2cd3",
          //   name: "jane@doe.com",
          //   created_at: "2022-02-21 10:00:00"
          // }
        ],

        filterType: "id",
        filterOptions: [
          { value: "name", text: "Name" },
          { value: "created_at", text: "Created At" },
        ],
        filterValue: "",

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      recalculate() {
        let pg = this.table.currentPage - 1

        let prev = pg * this.table.perPage + 1
        let limit = pg * this.table.perPage + this.table.perPage
        if (limit > this.table.totalRows) limit = this.table.totalRows
        if (this.table.totalRows == 0) prev = 0
        this.table.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.table.totalRows + " entri"
      }
    }
  },
  computed: {
    totalRows() {
      return this.table.totalRows;
    },
    currentPage() {
      return this.table.currentPage;
    }
  },
  watch: {

    totalRows(newVal) {
      this.recalculate()
    },

    currentPage(newVal) {
      this.recalculate()
    },

  },
  methods: {

    showCreateItemModal(event) {
      event.preventDefault()

      this.createEditItemAction = 'create'
      this.resetCreateEditItemFields()
      this.showCreateEditItemModal = true
    },

    showEditItemModal(id, name) {
      this.resetCreateEditItemFields()
      this.selectedItemId = id
      this.createEditItemAction = 'edit'
      this.createEditItem.name.value = name
      this.showCreateEditItemModal = true
    },

    resetCreateEditItemFields() {
      this.selectedItemId = 0
      this.createEditItem.name.value = ''
      for(const [key, data] of Object.entries(this.createEditItem)){
        data.isValid = null
      }
    },

    editItem(event) {
      event.preventDefault()

      this.isLoading.createEditItem = true
      let isFormValid = true

      let name = this.createEditItem.name
      if (name.isRequired && this.$helper.isEmpty(name.value)) {
        name.feedback = "This input is required."
        isFormValid = false
        name.isValid = false
      } else if (name.value.length < 3) {
        name.feedback = "Camera name should contain a minimum of 3 characters."
        isFormValid = false
        name.isValid = false
      } else{
        name.isValid = null
      }

      if (isFormValid) {
        // URL builder
        let putUrl = "/cameras"
        let obj = {
          id: this.selectedItemId,
          name: this.createEditItem.name.value,
        }
  
        this.$axios.put(putUrl, obj).then(response => {
          if(response.status == 200){
            if (response.data.success){
              this.$helper.toastSuccess(this, "Edit Camera Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
              this.resetCreateEditItemFields()
              this.showCreateEditItemModal = false
              this.getTableItems()
            } else{
              this.$helper.toastError(this, "Edit Camera Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            }
          }
          else{
            this.$helper.toastError(this, "Edit Camera Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Edit Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Edit Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isLoading.createEditItem = false
        })
      } else{
        this.isLoading.createEditItem = false
      }
    },

    confirmDeleteItem() {

      this.isLoading.deleteItem = true
      // URL builder
      let deleteUrl = "/cameras/" + this.deleteItem.id

      this.$axios.delete(deleteUrl).then(response => {
        if(response.status == 200){
          if (response.data.success){
            this.$helper.toastSuccess(this, "Delete Camera Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            this.showingDeleteModal = false
            this.getTableItems()
          } else{
            this.$helper.toastError(this, "Delete Camera Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        }
        else{
          this.$helper.toastError(this, "Delete Camera Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Delete Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Delete Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.deleteItem = false
      })
    },

    createItem(event) {
      event.preventDefault()

      this.isLoading.createEditItem = true
      let isFormValid = true

      let name = this.createEditItem.name
      if (name.isRequired && this.$helper.isEmpty(name.value)) {
        name.feedback = "This input is required."
        isFormValid = false
        name.isValid = false
      } else if (name.value.length < 3) {
        name.feedback = "Camera name should contain a minimum of 3 characters."
        isFormValid = false
        name.isValid = false
      } else{
        name.isValid = null
      }

      if (isFormValid) {
        // URL builder
        let postUrl = "/cameras"
        let obj = {
          name: this.createEditItem.name.value,
        }
  
        this.$axios.post(postUrl, obj).then(response => {
          if(response.status == 200){
            if (response.data.success){
              this.$helper.toastSuccess(this, "Create Camera Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
              this.resetCreateEditItemFields()
              this.showCreateEditItemModal = false
              this.getTableItems()
            } else{
              this.$helper.toastError(this, "Create Camera Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            }
          }
          else{
            this.$helper.toastError(this, "Create Camera Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Create Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Create Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isLoading.createEditItem = false
        })
      } else{
        this.isLoading.createEditItem = false
      }
    },

    showDeleteItemModal(id, name) {
      this.deleteItem.id = id
      this.deleteItem.name = name
      this.showingDeleteModal = true
    },

    onChangeFilterType() {
      if (this.table.filterType == "isLocked") {
        this.table.filterValue = "true"
      } else{
        this.table.filterValue = null
      }
    },

    getTableItems() {
      this.table.isLoaded = false
      this.table.items = []
      // URL builder
      let getUrl = "/cameras"
      let params = {}

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){

          this.table.items = response.data.data
          this.table.totalRows = response.data.data.length
          this.table.totalPages = response.data.data.length % this.table.perPage
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Camera Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },
  },

  created(){
    this.getTableItems()
  },
}
</script>

<style>

</style>
